import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import type { SemVer } from "util/version";

export const generateMappingFromAppBuild = (
  appBuild: string | undefined,
): string | undefined =>
  appBuild ? appBuild.replace("apk", "mapping.txt") : undefined;

// Create mappingBuildUrls by replacing "apk" with "mapping.txt" in each appBuildUrls.
export const generateMappingFromAppBuilds = (
  appBuildUrls: Record<string, string | undefined>,
): Record<string, string | undefined> =>
  Object.fromEntries(
    Object.entries(appBuildUrls).map(([key, url]) => [
      key,
      url ? generateMappingFromAppBuild(url) : undefined,
    ]),
  );

// Generate list of links of a mapping for the given versions.
export const generateMappingLinks = (
  versions: SemVer[],
  appBuildUrls: Record<string, string | undefined>,
): JSX.Element[] => {
  const mappingBuildUrls = generateMappingFromAppBuilds(appBuildUrls);

  return generateLinksBase(
    versions,
    strings.DownloadMapping,
    undefined,
    mappingBuildUrls,
  );
};
